import { Component, effect, inject, OnInit } from '@angular/core';
import { BookmarkStore } from '../../../stores/bookmark/bookmark.state';
import { Bookmark } from '../../../models/bookmark';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { ButtonDirective } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { PrimeTemplate } from 'primeng/api';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-confirm-delete-bookmark-link',
  standalone: true,
  imports: [
    AlertComponent,
    ButtonDirective,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    PrimeTemplate,
  ],
  templateUrl: './confirm-delete-bookmark-link.component.html',
  styleUrl: './confirm-delete-bookmark-link.component.scss',
})
export class ConfirmDeleteBookmarkLinkComponent {
  readonly store = inject(BookmarkStore);
  bookmark: Bookmark | null = null;

  constructor() {
    effect(() => {
      const state = getState(this.store);
      console.log(state);
      this.bookmark = this.store.selectedItem();
      console.log('bookmark: ', this.bookmark);
    });
  }
}
